var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0002 4H15.0002V2C15.0002 1.46957 14.7895 0.960859 14.4145 0.585786C14.0394 0.210714 13.5307 0 13.0002 0L7.00024 0C6.46981 0 5.9611 0.210714 5.58603 0.585786C5.21096 0.960859 5.00024 1.46957 5.00024 2V4H0.000244141V6H2.00024V21C2.00024 21.7956 2.31631 22.5587 2.87892 23.1213C3.44153 23.6839 4.20459 24 5.00024 24H15.0002C15.7959 24 16.559 23.6839 17.1216 23.1213C17.6842 22.5587 18.0002 21.7956 18.0002 21V6H20.0002V4ZM7.00024 2H13.0002V4H7.00024V2ZM16.0002 21C16.0002 21.2652 15.8949 21.5196 15.7074 21.7071C15.5198 21.8946 15.2655 22 15.0002 22H5.00024C4.73503 22 4.48067 21.8946 4.29314 21.7071C4.1056 21.5196 4.00024 21.2652 4.00024 21V6H16.0002V21Z",
    fill: "#DA1E27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 9.99902H7V17.999H9V9.99902Z",
    fill: "#DA1E27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.0005 9.99902H11.0005V17.999H13.0005V9.99902Z",
    fill: "#DA1E27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.c671f82aa55d0617800434e73248e346.svg";
export { ForwardRef as ReactComponent };